import { HTMLProps, PropsWithChildren } from 'react';
import { ButtonIntent, ButtonTier, IButtonProps } from './button.types';
import classnames from 'classnames';
import styles from './button.module.css';

export const Button = ({
  children,
  tier,
  intent,
  className,
  type,
  bigger = false,
  ...props
}: PropsWithChildren<IButtonProps & HTMLProps<HTMLButtonElement>>) => (
  <button
    type={(type as 'button' | 'submit' | 'reset') ?? 'button'}
    {...props}
    className={classnames(className, {
      [styles.button]: true,
      [styles.buttonPrimary]: tier === ButtonTier.Primary,
      [styles.buttonSecondary]: tier === ButtonTier.Secondary,
      [styles.buttonTertiary]: tier === ButtonTier.Tertiary,
      [styles.buttonNegative]: intent === ButtonIntent.Negative,
      [styles.buttonPositive]: intent === ButtonIntent.Positive,
      [styles.buttonBigger]: bigger,
    })}
  >
    {children}
  </button>
);
